import { Chart } from "chart.js";
import { ColorMode } from "./color-mode";

export type ChartTheme = {
  text: string;
  grid: string;
  canvas: string;
  notIndexed: string;
};

export function chartTheme(mode: ColorMode): ChartTheme {
  switch (mode) {
    case "dark":
      return {
        text: "#d1d5db",
        grid: "rgba(255, 255, 255, 0.12)",
        canvas: "#1f2937",
        notIndexed: "#4b5563",
      };
    case "light":
      return {
        text: "#666666",
        grid: "rgba(0, 0, 0, 0.1)",
        canvas: "#ffffff",
        notIndexed: "#d9d9d9",
      };
    default: {
      const unknownMode: never = mode;
      return unknownMode;
    }
  }
}

export function applyChartTheme(mode: ColorMode): void {
  const theme = chartTheme(mode);
  Chart.defaults.color = theme.text;
  Chart.defaults.borderColor = theme.grid;
}
